var React = require('react');

function Diagrams (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.2845 19.0511H0.000214168C0.475943 8.74543 8.74521 0.476143 19.0509 0.000428571V11.2847C14.965 11.72 11.7195 14.9655 11.2845 19.0511ZM33.4602 5.19114C30.1201 2.14871 25.7459 0.222429 20.9266 0V11.2843C22.6409 11.467 24.2074 12.1445 25.4802 13.1713L33.4602 5.19114ZM34.7866 6.51757L26.8066 14.4969C28.0179 15.9988 28.7436 17.9087 28.7436 19.9885C28.7436 24.8236 24.8239 28.7435 19.9886 28.7435C15.4704 28.7435 11.7521 25.3205 11.2836 20.9264H0C0.489957 31.5428 9.25143 39.9992 19.9886 39.9992C31.0407 39.9992 40 31.0399 40 19.9878C40.0003 14.7991 38.0254 10.0721 34.7869 6.51636L34.7866 6.51757Z"}));
}

Diagrams.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"currentColor"};

module.exports = Diagrams;

Diagrams.default = Diagrams;
